import {Component, OnInit} from '@angular/core';
import {FormComponent} from '@ngx-ivengi/crud';
import {UIRouter} from '@uirouter/angular';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {Charge} from './charge.model';
import {ChargeService} from './charge.service';
import {User} from '../user/user.model';
import {UserService} from '../user/user.service';

@Component({
  selector: 'app-charge-form',
  templateUrl: './charge-form.component.html'
})
export class ChargeFormComponent extends FormComponent implements OnInit {

  public charge: Charge = new Charge();
  public formTitle: string;
  public stateIdParam: string = 'chargeId';


  constructor(
    protected router: UIRouter,
    private chargeService: ChargeService,
    private translate: TranslateService
  ) {
    super(router);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.translate.get('charge.form.add.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;

      case this.FormMode.UPDATE: {
        this.translate.get('charge.form.update.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });

        this.chargeService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);
        this.chargeService.get(this.router.stateService.params[this.stateIdParam]).subscribe((charge) => {
          this.charge = charge;
        });
      } break;
    }
  }

  public save(): void {
    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.chargeService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);
        const currentStateParts = this.router.stateService.$current.name.split('.');
        currentStateParts.pop();
        const parentState = currentStateParts.join('.');

        this.chargeService.add(this.charge).subscribe((result) => {
          this.router.stateService.go(parentState, this.router.stateService.params, {reload: true});
        });
      } break;

      case this.FormMode.UPDATE: {
        this.chargeService.setRoutePrefix(`assignment/${this.router.stateService.params.assignmentId}`);
        const currentStateParts = this.router.stateService.$current.name.split('.');
        currentStateParts.pop();
        currentStateParts.pop();
        const parentState = currentStateParts.join('.');

        this.chargeService.update(this.charge).subscribe((result) => {
          this.router.stateService.go(parentState, this.router.stateService.params, {reload: true});
        });
      } break;
    }
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/charge/charge-form.component.ts